import { lazy } from "react";

export const SandboxRenderer = lazy(() =>
  import("../Components/SandboxRenderer/SandboxRenderer")
);
export const DesktopHeader = lazy(() =>
  import("../Components/HeaderComponent/DesktopHeader")
);
export const Login = lazy(() => import("../Components/Login/Login"));
export const HeaderComponent = lazy(
  () => import("../Components/HeaderComponent/HeaderComponent"),
);
export const BatchRequestManagement = lazy(
  () => import("../Components/BatchRequestManagement"),
);
export const Dashboard = lazy(
  () => import("../Components/StudentDashboard/StudentDashboard"),
);
export const ParentDashboard = lazy(
  () => import("../Components/ParentDashboard/ParentDashboard"),
);
export const StudentSummary = lazy(
  () => import("../Components/ParentDashboard/StudentSummary"),
);
export const BookDemo = lazy(
  () => import("../Components/ParentDashboard/bookADemoComponents/index.jsx"),
);
export const ViewSchedule = lazy(
  () => import("../Components/StudentDashboard/ViewSchedule/ViewSchedule"),
);
export const ViewScheduleV2 = lazy(() =>
  import("../Components/StudentDashboard/viewScheduleV2/index.jsx")
);
export const Referrals = lazy(() => import("../Components/Referral/Referral"));
export const RedeemRewards = lazy(
  () => import("../Components/Referral/ReferralV2/components/RedeemRewards"),
);
export const AchievementsIndex = lazy(
  () => import("../Components/NewReferalFlowForSC/index"),
);
export const PtmFeedBack = lazy(
  () => import("../Components/TeacherFeedbackForm/FeedBackForm"),
);
export const Referal = lazy(
  () => import("../Components/NewReferalFlowForSC/Referal"),
);
export const Resources = lazy(() => import("../Components/Resources/Resources"));
export const Subscriptions = lazy(
  () => import("../Components/Subscriptions/Subscriptions"),
);
export const Community = lazy(() => import("../Components/Community/Community"));
export const ShowAllProjects = lazy(
  () => import("../Components/Community/ShowAllProjects/ShowAllProjects"),
);
export const EditProfile = lazy(
  () => import("../Components/EditProfile/EditProfile"),
);
export const ZoomMeet = lazy(() => import("../Components/ZoomMeet/ZoomMeet"));
export const LeaveZoom = lazy(() => import("../Components/ZoomMeet/LeaveZoom"));
export const AutoReschedule = lazy(
  () => import("../Components/AutoReschedule/Reschedule"),
);
export const AddClassV2 = lazy(
  () => import("../Components/AutoReschedule/AddClassV2"),
);
// The route keeps its name; the seam decides which screen serves it —
// EditClass when studentportal_edit_class_revamp is on, the legacy screen when off.
export const CancelAndReschedule = lazy(
  () => import("../Components/CancelAndRescheduleV2/EditClassSeam"),
);
export const SlotSelectorPage = lazy(
  () => import("../Components/CancelAndRescheduleV2/SlotSelectorPageWrapper"),
);
export const ChangeBatchSchedule = lazy(
  () => import("../Components/ChangeBatchSchedule/Index"),
);
export const StudentCommunity = lazy(
  () => import("../Components/Community/studentCommunity"),
);
export const Error = lazy(() => import("../Components/error"));
export const PreviewAlchemyFile = lazy(
  () => import("../Components/Resources/Alchemy/PreviewAlchemyFile"),
);
export const ClassSummary = lazy(
  () => import("../Components/ClassSummary/Index.jsx"),
);
export const WeeklyReport = lazy(() => import("../Components/WeeklyReports"));
export const Notifications = lazy(() => import("../Components/Notifications"));
export const ReschedulePTM = lazy(() => import("../Components/ReschedulePTM"));
export const TeachersDayPostPage = lazy(
  () => import("../Components/Posts/index"),
);
export const WebinarPaymentStatusPage = lazy(
  () => import("../Components/Community/WebinarPurchase/SuccessPage/index.jsx"),
);
export const BuyCredits = lazy(
  () => import("../Components/BuyCredits/index.jsx"),
);

export const ConfirmDemoAttendance = lazy(
  () => import("../Components/ConfirmDemoAttendance/ConfirmDemoAttendance"),
);

export const LoopAction = lazy(
  () => import("../Components/LoopAction/LoopAction"),
);

export const FeatureFlagsDebug = lazy(
  () => import("../Components/FeatureFlagsDebug/FeatureFlagsDebug"),
);
